import { render, staticRenderFns } from "./MovementRouteDetail.vue?vue&type=template&id=1d0c112d"
import script from "./MovementRouteDetail.vue?vue&type=script&lang=js"
export * from "./MovementRouteDetail.vue?vue&type=script&lang=js"
import style0 from "./MovementRouteDetail.vue?vue&type=style&index=0&id=1d0c112d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports